module.exports = __webpack_public_path__ + "img/folios--icon.fd5f6ee1.svg";